import * as React from 'react';
import { Link } from 'react-router-dom';
import Project from 'src/entities/Project';
import NumberFormater from 'src/services/number-formater/NumberFormater.service';
import ImageContainer from 'src/modules/commons/images/Image.container';

export interface Props {
  project: Project;
}

const InvestedProjectCardComponent: React.StatelessComponent<Props> = (props: Props) => {
  const premoneyValuation = NumberFormater
    .euros(props.project.premoneyValuation);

  const myInvestment = NumberFormater
    .euros(props.project.invested.length ? props.project.invested[0].amountInvested : 0);
    
  let equity = (props.project.invested[0].quantityTickets * props.project.sharePercentage).toString();

  equity = parseFloat(equity).toLocaleString('es-ES', {maximumFractionDigits: 2});

  const endDate = props.project.endDate.format('DD-MM-YYYY');

  const getBadge = (status: string) => {
    if ((props.project.dueDiligenceStatus === 'In Progress') &&
      ((props.project.invested[0].dueDiligenceStatus === 'Requested') ||
        (props.project.invested[0].dueDiligenceStatus === 'NDA Signed'))) {
      return (
        <div className="padding-left-30">
          <span className="badge badge-blue"/>
          <strong className="blue-color-text"> Realizando Due Diligence </strong>
        </div>
      );
    } else {
      if (status !== 'Formalizando operación') {
        if (status === 'Financiado con éxito') {
          return (
            <div className="padding-left-30">
              <span className="badge badge-primary"/>
              <strong className="primary-color-text"> Financiado con éxito </strong>
            </div>
          );
        } else {
          return;
        }
      } else {
        switch (props.project.invested[0].status) {
          case 'Reviewing Profile':
            return (
              <div className="padding-left-30">
                <span className="badge badge-confirm"/>
                <strong className="confirm-color-text"> Datos de inversión no confirmados </strong>
              </div>
            );
          case 'Confirmed Profile':
            return (
              <div className="padding-left-30">
                <span className="badge badge-confirm"/>
                <strong className="confirm-color-text"> Importe de inversión no confirmado </strong>
              </div>
            );
          case 'Reviewing Amount Change':
            return (
              <div className="padding-left-30">
                <span className="badge badge-confirm"/>
                <strong className="confirm-color-text"> Validando tu petición </strong>
              </div>
            );
          case 'Confirmed Amount':
            return (
              <div className="padding-left-30">
                <span className="badge badge-confirm"/>
                <strong className="confirm-color-text"> Redactando contratos </strong>
              </div>
            );
          case 'Reviewing Contracts':
            return (
              <div className="padding-left-30">
                <span className="badge badge-confirm"/>
                <strong className="confirm-color-text"> Revisa los contratos de inversión </strong>
              </div>
            );
          case 'Reviewing Contracts Correction':
            return (
              <div className="padding-left-30">
                <span className="badge badge-confirm"/>
                <strong className="confirm-color-text"> Revisando la errata </strong>
              </div>
            );
          case 'Accepted Contracts':
            return (
              <div className="padding-left-30">
                <span className="badge badge-confirm"/>
                <strong className="confirm-color-text"> Firma de contratos de inversión </strong>
              </div>
            );
          case 'Signed Contracts':
            return (
              <div className="padding-left-30">
                <span className="badge badge-confirm"/>
                <strong className="confirm-color-text"> Desembolso de la inversión no realizado </strong>
              </div>
            );
          default:
            return;
        }
      }
    }
  };

  return (
    <Link to={'/ficha-de-operaciones/' + props.project.id}>
      <div className="projects-card-wallet pointer">
        <div
          className="simple-card"
          style={{
            height: '100%',
            width: '100%',
            position: 'relative',
            zIndex: 1,
            float: 'none',
            display: 'inline-table',
            padding: '20px 0'
          }}
        >
          <div className="col-sm-4">
            <p className="padding-left-30">
              <ImageContainer
                alt={props.project.company.name + ' logo'}
                className="img-responsive"
                url={props.project.company.logo}
              />
            </p>
            <div className="gap-10 hidden-xs hidden-sm"/>
            <p className="padding-left-30">
              Cierre de la ronda: {endDate}
            </p>
            {getBadge(props.project.status!)}
          </div>
          <div className="custom-col-xs-6 col-xs-6 col-sm-4">
            <div className="gap-10 hidden-xs"/>
            {props.project.premoneyValuation === 0 ?
              null :
              <div className="icon-content">
                <img
                  alt="Euro"
                  className="icon"
                  src="./img/analytics-big.png"
                />
                <p className="inline-block f-s-22">
                  Valoración inicial:
                  <br/>
                  <strong>
                    {premoneyValuation}
                  </strong>
                </p>
              </div>
            }
            <div className="icon-content">
              <img
                alt="Euro"
                className="icon"
                src="./img/dollar-big.png"
              />
              <p className="inline-block f-s-22">
                Mi inversión:
                <br/>
                <strong>{myInvestment}</strong>
              </p>
            </div>
          </div>
          <div className="custom-col-xs-6 col-xs-6 col-sm-4">
            <div className="gap-10 hidden-xs"/>
            {props.project.premoneyValuation === 0 ?
              null :
              <div className="icon-content">
                <img
                  alt="Euro"
                  className="icon"
                  src="./img/percent-big.png"
                />
                <p className="inline-block f-s-22">
                  Mi porcentaje:
                  <br/>
                  <strong>{equity} %</strong>
                </p>
              </div>
            }
          </div>
        </div>
      </div>
    </Link>
  );
};

export default InvestedProjectCardComponent;



// WEBPACK FOOTER //
// ./src/modules/my-portfolio/partials/InvestedProjectCard.component.tsx